import { getDocsUrl } from 'utils/docs-url';

// Environment-aware docs URL, matching the pattern used by nav-drawer and
// the GoogleCalendarIntegration view. Falls back to prod docs when VITE_HOST
// is not set (e.g., during test builds).
export const DNC_API_DOCS_URL = `${getDocsUrl() ?? 'https://docs.aktify.io'}/api/create-dnc`;
